<ng-container *renderIf="item.role">
  <ng-container *ngIf="!item.hidden">
    <!-- item.url -->
    <a class="dropdown-item d-flex align-items-center" [ngClass]="[item.classes || '', class]" placement="bottom"
      [ngbTooltip]="child ? undefined: item.title" *ngIf="item.url && !item.externalUrl" [routerLink]="[item.url]"
      [target]="item.openInNewTab ? '_blank' : '_self'">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>

    <!-- item.externalUrl -->
    <a class="dropdown-item d-flex align-items-center" [ngClass]="[item.classes || '', class]" placement="bottom"
      [ngbTooltip]="child ? undefined: item.title" *ngIf="item.url && item.externalUrl" (click)="handleExternalUrl()">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>

    <ng-template #itemContent>
      <img [src]="iconPrefix+item.icon" alt="" [width]="child ? 24 : 28" [height]="child ? 24 : 28"
        [ngClass]="{'mr-50':child}">
      <span *ngIf="child">{{ item.title }}</span>
    </ng-template>
  </ng-container>
</ng-container>